import { clearNetworkErrorModal } from "@/redux/auth";
import { useAppDispatch, useAppSelector } from "@/redux/hook";

import ErrorSuccessModal from "@/components/commons/ErrorSuccessModal/ErrorSuccessModal";

const GlobalNetworkErrorModal = () => {
  const dispatch = useAppDispatch();
  const showNetworkErrorModal = useAppSelector(
    (state) => state.auth.showNetworkErrorModal
  );

  const handleNetworkError = () => {
    dispatch(clearNetworkErrorModal());
  };

  if (!showNetworkErrorModal) {
    return null;
  }

  return (
    <ErrorSuccessModal
      type="error"
      isOpen={showNetworkErrorModal}
      title="Error"
      message="Network Error. Check your connection and try again."
      buttonText="OK"
      onPress={handleNetworkError}
      statusCode={401}
    />
  );
};

export default GlobalNetworkErrorModal;
